import { t } from '@avalara/bat-apps-shared/i18n';
import { SCardAction, SCol, SIcon, SRow } from '@avalara/skylab-sdk/react';

import '../product-catalog.css';

import type { TranslationKey } from '@avalara/bat-apps-shared/i18n';
import type { ProductDetailSection, ProductFeatureCard } from '../../../../../types/product-detail';

const MEDIUM_SIZED_ICONS = new Set(['globe', 'lightbulb-lit', 'math', 'wrench']);

type Props = {
  features: ProductDetailSection<ProductFeatureCard>;
  sectionIndex: number;
};

const ProductDetailFeatureCards = ({ features: { heading, description, items }, sectionIndex }: Props) => {
  if (!items.length) return null;

  return (
    <div className='margin-top-lg pad-top-xl' data-ref={`buy.product-detail.feature-cards-section.${sectionIndex}`}>
      {heading && (
        <h2 className='product-detail-section-heading' data-ref={`buy.product-detail.features.${sectionIndex}.heading`}>
          {t(heading as TranslationKey)}
        </h2>
      )}
      {description && (
        <p data-ref={`buy.product-detail.features.${sectionIndex}.subheading`}>{t(description as TranslationKey)}</p>
      )}
      <SRow data-ref={`buy.product-detail.feature-cards.${sectionIndex}`}>
        {items.map((feature, index) => (
          <SCol
            className={index === 0 ? 'pad-left-none' : ''}
            key={feature.title}
            span='auto'
            data-ref={`buy.product-detail.feature-card.${sectionIndex}.${index}`}
          >
            <SCardAction className='product-detail-feature-card'>
              <div slot='title' className='flex flex-dir-col'>
                <span>
                  <SIcon
                    className={['product-detail-feature-card-icon', MEDIUM_SIZED_ICONS.has(feature.icon) && 'medium']
                      .filter(Boolean)
                      .join(' ')}
                    name={feature.icon}
                    aria-hidden='true'
                  />
                </span>

                <h3>{feature.title}</h3>
              </div>
              <div slot='description'>
                <p>{feature.description}</p>
              </div>
            </SCardAction>
          </SCol>
        ))}
      </SRow>
    </div>
  );
};

export default ProductDetailFeatureCards;
